import React, { useCallback, useState } from "react";
import "./App.css";
import { EvidenceManager } from "./EvidenceManager";
import { GhostSuggestions } from "./GhostSuggestions";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { ObjectiveAdder } from "./ObjectiveAdder";
import { SelectedItem } from "./SelectedItem";
import appHeader from "./AppHeader.png";
const objectives = [
  "Witness ghost event",
  "Capture photo of ghost",
  "Find EMF evidence",
  "Motion Sensor reading",
  "Cleanse area with smudge sticks",
  "Prevent hunt with crucifix",
  "Detect ghost with salt",
  "Have ghost blow out candle",
  "Escape a hunt",
  "Use smudge sticks during hunt",
  "Get an average sanity below 25%",
];

function App() {
  const [showRuleOut, setShowRuleOut] = useState(false);
  const [selectedEvidence, setSelectedEvidence] = useState([]);
  const [ruledOutEvidence, setRuledOutEvidence] = useState([]);
  const [suggestedGhosts, setSuggestedGhosts] = useState([]);
  const [ghostName, setGhostName] = useState("");
  const [enableObjectiveAdder, setEnableObjectiveAdder] = useState(false);
  const [highlightedObjectives, setHighlightedObjectives] = useState([]);
  const onEvidenceChanged = (newEvidence) => {
    let updatedEvidence = newEvidence.map((x) => x);
    setSelectedEvidence(updatedEvidence);
  };
  const onRuledOutEvidenceClicked = (clickedEvidence) => {
    let updatedRuledEvidence = ruledOutEvidence.map((x) => x);
    if (ruledOutEvidence.includes(clickedEvidence)) {
      updatedRuledEvidence = updatedRuledEvidence.filter(
        (x) => x !== clickedEvidence
      );
    } else {
      updatedRuledEvidence.push(clickedEvidence);
    }
    setRuledOutEvidence(updatedRuledEvidence);
  };
  const onSuggestionsChanged = useCallback(
    (suggestions) => {
      setSuggestedGhosts(suggestions);
    },
    [setSuggestedGhosts]
  );

  const onReset = () => {
    setSelectedEvidence([]);
    setRuledOutEvidence([]);
    setGhostName("");
    setHighlightedObjectives([]);
  };
  const onAddObjective = (e) => {
    e.stopPropagation();
    setEnableObjectiveAdder(!enableObjectiveAdder);
  };
  const onObjectedAdderClosed = () => {
    setEnableObjectiveAdder(false);
  };
  debugger;
  let evidenceNeededForSuggestions = suggestedGhosts.flatMap((x) => x.symptoms);
  return (
    <AppPanel onClick={() => setEnableObjectiveAdder(false)}>
      <Helmet>
        <title>Phasmophobia Helper</title>
      </Helmet>
      <AppContent>
        <div className="App-Content">
          <HeaderContainer>
            <HeaderToolsLayout>
              <Button onClick={onReset}>Reset</Button>
              <Label>
                Ghost Name:
                <GhostNameInput
                  value={ghostName}
                  onChange={(e) => {
                    setGhostName(e.target.value);
                  }}
                />
              </Label>
              <CheckboxLabel htmlFor="showRuleOut">
                <ShowRuleOutCheckbox
                  onChange={(e) => {
                    setShowRuleOut(e.target.checked);
                    setRuledOutEvidence([]);
                  }}
                  type="checkbox"
                  id="showRuleOut"
                ></ShowRuleOutCheckbox>
                Show Rule Out
              </CheckboxLabel>
              {highlightedObjectives.length < 3 && (
                <Button onClick={onAddObjective}>Add Objectives</Button>
              )}
              <ObjectiveAdder
                show={enableObjectiveAdder}
                selectedObjectives={highlightedObjectives}
                onClosed={onObjectedAdderClosed}
                objectives={objectives}
                onObjectivesChanged={(newList) => {
                  setHighlightedObjectives(newList);
                  setEnableObjectiveAdder(newList.length < 3);
                }}
              />
              {highlightedObjectives.length > 0 && (
                <SelectedObjectivesPanel>
                  <Header>Objectives:</Header>
                  <ObjectiveList>
                    {highlightedObjectives.map((x) => (
                      <SelectedItem
                        itemValue={x}
                        onRemoved={() => {
                          setHighlightedObjectives((current) =>
                            current.filter((c) => c !== x)
                          );
                        }}
                      ></SelectedItem>
                    ))}
                  </ObjectiveList>
                </SelectedObjectivesPanel>
              )}
            </HeaderToolsLayout>
          </HeaderContainer>
          <AppMain>
            {highlightedObjectives.length > 0 && (
              <MobileObjectivesPanel>
                <Header>Objectives:</Header>
                <ObjectiveList>
                  {highlightedObjectives.map((x) => (
                    <SelectedItem
                      itemValue={x}
                      onRemoved={() => {
                        setHighlightedObjectives((current) =>
                          current.filter((c) => c !== x)
                        );
                      }}
                    ></SelectedItem>
                  ))}
                </ObjectiveList>
              </MobileObjectivesPanel>
            )}

            <EvidenceManager
              showRuleOut={showRuleOut}
              ruledOutEvidence={ruledOutEvidence}
              selectedEvidence={selectedEvidence}
              onRuledOutEvidenceClicked={onRuledOutEvidenceClicked}
              onEvidenceChanged={onEvidenceChanged}
              evidenceNeededForSuggestions={evidenceNeededForSuggestions}
            ></EvidenceManager>
            <GhostSuggestions
              ruledOutEvidence={ruledOutEvidence}
              onSuggestionsChanged={onSuggestionsChanged}
              selectedEvidence={selectedEvidence}
            ></GhostSuggestions>
          </AppMain>
        </div>
      </AppContent>
      <AppBrandingContainer>
        <AppLogo></AppLogo>
      </AppBrandingContainer>
    </AppPanel>
  );
}
const SelectedObjectivesPanel = styled.div`
  border: 1px solid #5181ac;
  overflow: hidden;
  margin: 0px 10px;
  @media (max-width: 749px) {
    visibility: hidden;
    width: 0px;
    height: 0px;
  }
`;
const ObjectiveList = styled.div`
  display: flex;
`;
const MobileObjectivesPanel = styled.div`
  border: 1px solid #5181ac;
  margin: 5px 10px;
  max-width: 100%;
  @media (min-width: 750px) {
    visibility: hidden;
    width: 0px;
    height: 0px;
  }
`;
const AppMain = styled.div`
  overflow: auto;
  width: 100%;
  @media (max-width: 750px) {
    position: absolute;
    top: 60px;
    bottom: 60px;
    right: 0px;
    left: 0px;
  }
`;
const AppContent = styled.div``;
const HeaderContainer = styled.div`
  background: black;
  width: 100%;
  @media (min-width: 1000px) {
    width: calc(100% - 11.25rem);
    margin-left: 180px;
  }
`;
const AppBrandingContainer = styled.div`
  background: black;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 4.7rem;
  width: 16rem;
  right: 15%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1000px) {
    top: unset;
    bottom: 0px;
    width: 100%;
    height: 10vh;
  }
`;

const AppLogo = styled.div`
  background: black;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-image: url(${appHeader});
  background-position-y: bottom;
  background-position-x: left;
  background-repeat: no-repeat;
  @media (max-width: 1000px) {
    background-position-x: center;
  }
`;
// background-image: url("./AppHeader.png");
// background-size: 20px 50px;
// background-position-y: bottom;
// background-position-x: center;
// background-repeat: no-repeat;
const Header = styled.div`
  text-align: left;
  margin-right: auto;
  margin-left: 5px;
  @media (max-width: 750px) {
    font-size: 14px;
  }
`;
const Label = styled.label`
  margin-top: auto;
  margin-bottom: auto;
`;
const GhostNameInput = styled.input`
  margin-left: 5px;
  margin-right: 50px;
  width: 90px;
  @media (max-width: 1000px) {
    margin-right: 15px;
  }
  @media (max-width: 750px) {
    margin-right: 0px;
  }
`;
const CheckboxLabel = styled.label`
  margin-top: auto;
  margin-bottom: auto;
`;
const ShowRuleOutCheckbox = styled.input`
  margin-top: auto;
  margin-bottom: auto;
`;
const HeaderToolsLayout = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 75px;
  background: black;
  @media (max-width: 1000px) {
    background: unset;
    overflow: hidden;
  }
  @media (max-width: 750px) {
    height: unset;
  }

  @media (min-width: 1001px) {
  }
`;
const AppPanel = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  text-align: center;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;

  /*
  Introduced in IE 10.
  See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
*/
  -ms-user-select: none;
  user-select: none;
  overflow: auto;
`;
const Button = styled.button`
  background: #5181ac;
  margin-top: 5px;
  margin-right: 50px;
  margin-left: 15px;
  margin-bottom: 5px;
  border-thickness: 0px;
  :hover& {
    background: #7ab6db;
  }
  @media (max-width: 1000px) {
    margin-right: 15px;
  }
  color: white;
  padding: 15px;
  border: none;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  @media (max-width: 750px) {
    margin-left: 0px;
    margin-right: 0px;
    padding: 5px;
  }
`;

export default App;
